/**
 * @description Main App discount CRUD client for `/api/discounts` (LYN-248).
 * @dependencies apiClient (session + X-Company-Id). Do not send Payload tenant or Wristband tnt_id.
 * @notes Wave 1 owns the routes. Soft-delete is DELETE → status=inactive. Money: cents for fixed_amount.
 */

import apiClient from './apiClient';

const discountsService = {
  getDiscounts: async (params) => {
    const response = await apiClient.get('/discounts', { params });
    return response.data?.discounts || [];
  },

  getDiscount: async (discountId) => {
    const response = await apiClient.get(`/discounts/${discountId}`);
    return response.data?.discount;
  },

  createDiscount: async (data) => {
    const response = await apiClient.post('/discounts', data);
    return response.data?.discount;
  },

  updateDiscount: async (discountId, data) => {
    const response = await apiClient.put(`/discounts/${discountId}`, data);
    return response.data?.discount;
  },

  deleteDiscount: async (discountId) => {
    const response = await apiClient.delete(`/discounts/${discountId}`);
    return response.data?.discount;
  }
};

export default discountsService;
